export default "__VITE_ASSET__DWWnfl5x__"